import { setErrorObject, showErrorMessageInfo } from '../../actions/shared/HTTPError';
import fetcher from '../../modules/ajio-fetch';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  noJSONResHandler,
  getErrorStatusCode,
  errorParser
} from '../../modules/ajio-fetch/utils';
import { tokenReCreateParser } from '../../modules/ajio-fetch/utils';
import {
  gtmRefundEvent,
  gtmEventPush,
  gtmGA4RefundEvent,
  getStoreName,
  segmentEventPush
} from '../../modules/ga/GTMdatalayer';
import { getGA4AJIOEnable } from '../../refresh/selectors/featureFlagsSelector';
import { setAddress } from './addressBook';
import { storageAvailable } from '../../components/common/storageAvailable';
import { gaForOrderListing } from '../../refresh/utils/orderFilterUtils';
import { showLoader, hideLoader } from '../../actions/shared/loader';
import getEncryptedData from '../../utils/encryption';
import { getGiftItemData } from '../../refresh/templates/OrderShipmentDetails/GiftWithPurchase/GiftWithPurchase';
/*
  function to get the address details from API
*/

export function setReturnExchangeOrder(returnExchangeOrder = {}) {
  return {
    type: 'SET_RETURN_EXCHANGE_ORDER',
    returnExchangeOrder
  };
}

function setOrdersData(ordersData = {}) {
  return {
    type: 'GET_USER_ORDERS_DATA',
    ordersData
  };
}

function setOrderLevelDetail(orderLevelDetail = {}) {
  return {
    type: 'GET_ORDER_LEVEL_DATA',
    orderLevelDetail
  };
}

function clawbackBankDiscountResponse(data = {}, meta) {
  console.log("data", data, "meta", meta);
  return {
    type: 'CLAWBACK_BANK_DISCOUNT',
    payload: data,
    meta
  };
}

function setFailure(failure = false, message = '') {
  return {
    type: 'SET_FAILURE',
    failure,
    message
  };
}

function setImpsDetail(impsObj) {
  return {
    type: 'SET_IMPS_DATA',
    impsResObj: impsObj
  };
}

export function setView() {
  return {
    type: 'ACCOUNY_PAGE_RENDER'
  };
}
function getQuesAnsResponse(payload) {
  return {
    type: 'GET_QUICK_LINK_LIST',
    payload
  };
}
export function updateData({ key = '', value }) {
  let actionObj = {};
  if (key) {
    let isStorageAvailable = storageAvailable('sessionStorage');
    if (isStorageAvailable && key == 'userData') {
      let userData = sessionStorage.getItem('userData');
      let newUserData = {};
      if (userData) {
        newUserData = { ...JSON.parse(userData) };
      }
      newUserData[key] = value;
      sessionStorage.setItem('userData', JSON.stringify(newUserData));
    }
    actionObj.value = value;
    actionObj.key = key;
    actionObj.type = 'UPDATE_EXCHANGE_STORE_DATA';
    return actionObj;
  }
}

export const updateReturnExchangeUserData = ({ key, value, deleteKey }) => (dispatch, getState) => {
  const { returnExchange: { userData = {} } = {} } = getState();
  const newUserData = { ...userData };
  if (key) {
    newUserData[key] = value;
    if (deleteKey) {
      delete newUserData[key];
    }
    dispatch(
      updateData({
        key: 'userData',
        value: newUserData
      })
    );
  }
};

export function getOrderData(requestObj = {}) {
  let { request = {} } = requestObj;
  let { consignmentCode = '', orderNumber = '' } = request.query;
  return dispatch => {
    let body = {};
    let { headers: { host = '' } = {} } = request;
    let apiEndPoint = `http://${host}/api/my-account/get-orders/${orderNumber}/${consignmentCode}`;
    if (Object.keys(request.cookies).length) {
      body = {
        A: request.cookies.A,
        U: request.cookies.U,
        deviceId: request.cookies._fpuuid
      };
    }

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        body: JSON.stringify(body),
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const { addressList = {} } = response;
        const { exchangeNudge = {}, ...rest } = response;
        dispatch(setAddress(addressList));
        // console.log('return order data check ',response);
        // response = getDataFromStorage(response);
        dispatch(setOrderLevelDetail({ exchangeNudge }));
        dispatch(setReturnExchangeOrder(rest));
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              getOrderData(requestObj)(dispatch);
            });
          }
          dispatch(setErrorObject(errorObj));
        });
      });
  };
}

// Post Order flow: full order details
function formatOrderTracking(status_history, promisedDeliveryDate = '') {
  let orderTracking = [];
  let outForDelFlag = true;
  if (status_history.length > 0) {
    status_history.forEach((arrayEL, index) => {
      let { status = '', updateDate = '' } = arrayEL;
      let statusObj = {};
      if (status === ('PAYMENT UNSUCCESSFUL' || 'DELIVERED' || 'PAYMENT_UNSUCCESSFUL')) {
        return;
      }
      if (status === 'OUT FOR DELIVERY' || status === 'OUT_FOR_DELIVERY') {
        status = 'OUT_FOR_DELIVERY';
        outForDelFlag = true; // check for out for delivery option, only then to create arriving key
      }
      if (status === ('CREATED' || 'CONFIRMED')) {
        status = 'CONFIRMED';
      }
      statusObj.key = `|${status}`;
      statusObj.value = `${updateDate}|`;
      orderTracking.push(statusObj);
    });
    if (outForDelFlag) {
      let statusObj = {
        key: '|ARRIVING',
        value: `${promisedDeliveryDate}|` // promise delivery date
      };
      orderTracking.push(statusObj);
    }
    return orderTracking;
  }
  return [];
}

export function dateFormatter(dateVal) {
  let d = new Date(dateVal);
  let monthArr = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  let dayArr = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  if (d.valueOf()) {
    // Valid date
    let year = d.getFullYear();
    let month = d.getMonth();
    let day = d.getDate();
    let dayOfWeek = d.getDay();
    let hours = d.getHours();
    let minutes = d.getMinutes();
    let period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    let formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}${period}`;
    return {
      date: `${day} ${monthArr[month]}-${year}`,
      day: dayArr[dayOfWeek],
      time: formattedTime
    };
  }
  return { date: '  - ', day: ' ' };
}

function formatStatusMsgs(order, status_history = []) {
  let {
    status = '',
    eddUpperRange = '',
    eddLowerRange = '',
    promisedDeliveryDate = '',
    orderType = '',
    estimatedPickupDate = ''
  } = order;
  let displayStatus = '';
  let msg = '';
  let statusDate = '';
  if (orderType.includes('Self ship')) {
    msg = 'Self ship';
    return { displayStatus, msg };
  }
  switch (status.toUpperCase()) {
    case 'CREATED':
      displayStatus = 'Confirmed';
      msg = `Estimated delivery : ${dateFormatter(eddLowerRange).date.split('-')[0]} - ${
        dateFormatter(eddUpperRange).date.split('-')[0]
      }`;
      return { displayStatus, msg };
    case 'CONFIRMED':
      displayStatus = 'Confirmed';
      msg = `Estimated delivery : ${dateFormatter(eddLowerRange).date.split('-')[0]} - ${
        dateFormatter(eddUpperRange).date.split('-')[0]
      }`;
      return { displayStatus, msg };
    case 'PACKED':
      displayStatus = `Arriving between ${dateFormatter(eddLowerRange).date.split(' ')[0]} - ${
        dateFormatter(eddUpperRange).date.split('-')[0]
      }`;
      return { displayStatus, msg };
    case 'SHIPPED':
      displayStatus = `Arriving by ${dateFormatter(promisedDeliveryDate).date.split('-')[0]}`;
      return { displayStatus, msg };
    case 'OUT FOR DELIVERY':
      displayStatus = 'Out for delivery';
      return { displayStatus, msg };
    case 'DELIVERED':
      status_history.forEach((el, idx) => {
        if (el.status === 'DELIVERED') {
          let { updateDate = '', description = '' } = el;
          statusDate = updateDate;
        }
      });
      displayStatus = 'Delivered';
      msg = `Delivered on ${dateFormatter(statusDate).day}, ${
        dateFormatter(statusDate).date.split('-')[0]
      }`;
      return { displayStatus, msg };
    case 'RETURN PICKED':
      status_history.forEach((el, idx) => {
        if (el.status === 'RETURN PICKED') {
          let { updateDate = '', description = '' } = el;
          statusDate = updateDate;
        }
      });
      msg = msg = `${dateFormatter(statusDate).day}, ${
        dateFormatter(statusDate).date.split('-')[0]
      }`;
      return { displayStatus, msg };
    case 'RETURN COMPLETE':
      status_history.forEach((el, idx) => {
        if (el.status === 'RETURN COMPLETE') {
          let { updateDate = '', description = '' } = el;
          statusDate = updateDate;
        }
      });
      msg = `${dateFormatter(statusDate).day}, ${dateFormatter(statusDate).date.split('-')[0]}`;
      return { displayStatus, msg };
    case 'CANCELLED':
      status_history.forEach((el, idx) => {
        if (el.status === 'CANCELLED') {
          let { updateDate = '', description = '' } = el;
          statusDate = updateDate;
        }
      });
      displayStatus = 'Cancelled';
      msg = `Cancelled on ${dateFormatter(statusDate).day}, ${
        dateFormatter(statusDate).date.split('-')[0]
      }`;
      return { displayStatus, msg };
    default:
      return { displayStatus, msg };
  }
}


function formatOrders(ordersCollection) {
  let { orders = [], currentPage = '', pageSize = '', totalPages = 0, ...rest } = ordersCollection;
  if (Object.keys(ordersCollection).length <= 0) return {};
  let formattedOrders = { ...rest };
  formattedOrders.pagination = {
    currentPage,
    pageSize,
    totalPages
  };
  let new_order_list = [];
  orders.forEach((arrayEL, index) => {
    if (!arrayEL || Object.keys(arrayEL).length === 0) {
      return;
    }
    let validOrder = true;
    let { orderItemLines = [], ...rst } = arrayEL;
    let newItems = [];
    orderItemLines.forEach((el, idx) => {
      let { statusHistory = [], ...restData } = el;
      let { status = '', promisedDeliveryDate = '' } = restData;
      // if(statusDescription===' ') statusDescription='';
      if (
        status === 'PAYMENT UNSUCCESSFUL' ||
        status === 'PAYMENT_PENDING' ||
        status === 'PAYMENT_UNSUCCESSFUL'
      )
        validOrder = false;
      let track_data = [];
      // let { msg='' } = formatStatusMsgs({...restData},statusHistory);
      track_data = formatOrderTracking(statusHistory, promisedDeliveryDate);
      newItems.push({ ...restData, status_history: track_data });
    });
    new_order_list.push({ ...rst, orderItemLines: newItems, validOrder });
  });
  formattedOrders = { ...formattedOrders, order_list: new_order_list };
  // console.log('formatted orders ',formattedOrders);
  return formattedOrders;
}

export function getUserOrders(requestObj = {}) {
  let { request = {} } = requestObj;
  let { page = 0, pageSize = 10, dateRange = 'LAST6MONTH', filters = '' } = request.query;
  return dispatch => {
    let body = {};
    let { headers: { host = '' } = {}, cookies = {} } = request;
    let apiEndPoint = `http://${host}/api/my-account/get-user-orders/${page}/${pageSize}/${dateRange}`;

    if (filters) {
      apiEndPoint += `?filters=${filters}`;
    }

    if (Object.keys(cookies).length) {
      body = {
        A: request.cookies.A,
        U: request.cookies.U,
        R: request.cookies.R
      };
    }
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        body: JSON.stringify(body),
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(noJSONResHandler)
      .then(response => {
        let ordersData = formatOrders(response);
        if (!response.orders) {
          dispatch(
            setFailure(
              true,
              'Oops! We are unable to load your orders at the moment. Please try again in sometime'
            )
          );
        }
        dispatch(setOrdersData(ordersData));
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              getUserOrders(requestObj)(dispatch);
            });
          }
          dispatch(setErrorObject(errorObj));
        });
      });
  };
}

// Browser order request

export function getUserPaginationOrders(page, pageSize, dateRange = 'LAST6MONTH', filters = '') {
  return dispatch => {
    dispatch(showLoader('order-loader'));
    let apiEndPoint = `/api/my-account/get-user-orders/${page}/${pageSize}/${dateRange}`;

    if (filters) {
      apiEndPoint += `?filters=${filters}`;
    }

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json', credentials: 'include' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        // console.log('api in hget orders action ',data);
        let ordersData = formatOrders(response);
        // GA Events
        gaForOrderListing(ordersData, dateRange);
        dispatch(setOrdersData(ordersData));
        window.scrollTo(0, 0);
        dispatch(hideLoader('order-loader'));
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              getUserPaginationOrders(page, pageSize, dateRange)(dispatch);
            });
          }
          dispatch(setErrorObject(errorObj));
        });
        dispatch(hideLoader('order-loader'));
      });
  };
}

// format shipmentTracking data in orderLevelDetails
function formatOrderLevelDetailTracking(dataResponse = {}) {
  let confirmedDate = '';
  let arrivedDate = '';
  let orderResponse = {};
  if (dataResponse.orderResponse) orderResponse = dataResponse.orderResponse;
  if (orderResponse.created) confirmedDate = orderResponse.created;
  if (orderResponse.consignmentsData) {
    orderResponse.consignmentsData.map(item => {
      if (confirmedDate)
        item.shipmentTracking.push({ key: '|CONFIRMED', value: `${confirmedDate}|` });
      arrivedDate = item.expectedDeliveryDate ? item.expectedDeliveryDate : item.eddUpper;
      if (item.shipmentTracking.length > 0)
        item.shipmentTracking.push({ key: '|ARRIVING', value: `${arrivedDate}|` });
    });
  }
  return dataResponse;
}
// Post Order flow: order level detail

export function getUserOrderLevelDetail(requestObj = {}) {
  let { request = {} } = requestObj;
  let { orderId = '', oid = '' } = request.query;
  const { originalUrl = '' } = request || {};
  const newOrderId = originalUrl.includes('/rcc') ? oid : orderId

  return dispatch => {  
    let body = {};
    let { headers: { host = '' } = {} } = request;
    let apiEndPoint = `http://${host}/api/my-account/get-order-level-detail/${newOrderId}`;

    if (Object.keys(request.cookies).length) {
      body = {
        A: request.cookies.A,
        U: request.cookies.U,
        deviceId: request.cookies.deviceId,
        customerType: request.cookies.customerType
      };
    }

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        body: JSON.stringify(body),
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        let orderLevelDetail = formatOrderLevelDetailTracking(response);
        dispatch(setOrderLevelDetail(response));
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              getUserOrderLevelDetail(requestObj)(dispatch);
            });
          }
          dispatch(setErrorObject(errorObj));
        });
      });
  };
}

function clawbackBankDiscountAPI(orderNo,data = {}) {
  const apiEndpoint = `/api/my-account/clawbackCancelOrder/${orderNo}`;
  return fetcher(apiEndpoint, fetchGetJSONReqOpts({ method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) })).then(fetchGetJSONResHandler);
}


export function clawbackBankDiscount(orderNo, reqObj = {}, refundType = '', key = '') {
  return dispatch => {
    const line = reqObj?.orderItemLines?.[0] || {};
    const quantity = line?.quantity;
    const itemId = line?.itemId;
    const cacheKey = key || `${orderNo}_${itemId}_${quantity}`;
    const payload = { ...reqObj, refundType };
    dispatch(showLoader('bank-discount-loader'));
    return clawbackBankDiscountAPI(orderNo, payload)
      .then(response => {
        dispatch(clawbackBankDiscountResponse(response?.data, {
          quantity,
          cacheKey,
          refundType: refundType
        }));
        dispatch(hideLoader('bank-discount-loader'));
        return Promise.resolve(response);
      })
      .catch(error => {
        dispatch(setErrorObject('Something Went Wrong'));
        dispatch(hideLoader('bank-discount-loader'));
        return Promise.reject(error);
      });
  };
}


// Cancel item
export function cancelOrderItem(
  orderId,
  productCode,
  requestObj = {},
  enable_cancellation_request,
  cancelationRequestOldFlag,
  cancelledProductDetails = {},
  isGiftWithProductFlagOn,
  confirmedEntries,
  giftWithProductConfig,
  extraParams = {}
) {
  return dispatch => {
    dispatch(showLoader('order-loader'));
    let apiEndPoint = `/api/my-account/cancel-order-item/${orderId}/${productCode}`;
    const updatedRequestObj = {
      ...requestObj
    };

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        body: JSON.stringify(updatedRequestObj),
        method: 'POST',
        headers: { 'content-type': 'application/json', credentials: 'include' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        let messageBar = {
          errorType: 'info',
          message:
            cancelationRequestOldFlag === 'ON'
              ? enable_cancellation_request == 'ON'
                ? 'Cancelation requested for the item'
                : 'Order has been Canceled'
              : 'Order has been Canceled'
        };
        // console.log(response);
        const productsForGa = {};
        const {
          name = '',
          brandName = '',
          size = '',
          baseProduct = '',
          segmentId = '',
          experimentId = '',
          productIndex = 0,
          finalPrice,
          wasPrice,
          discount,
          tax,
          productShipping,
          couponSavings,
          product_rating,
          number_of_ratings_collected,
          product_brick,
          product_vertical,
          product_segment,
          product_brand,
          product_tag,
        } = cancelledProductDetails;

        const dimension60Data =
          Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';
        let gwpDimension = '';
        let giftItemQty = 0;
        const { totalQty = 1, qtyCanceled = 1 } = requestObj;
        const remainingQty = totalQty - qtyCanceled;
        if (isGiftWithProductFlagOn && remainingQty === 0) {
          const mainProduct = confirmedEntries.find(x => x?.entry?.product?.code === productCode);
          giftItemQty = mainProduct?.entry?.giftProductsCount || 0;
          if (giftItemQty > 0) {
            gwpDimension = `GetFreebies - ${giftItemQty}`;
          }
        }
        if (requestObj.qtyCanceled && productCode) {
          const isLuxe = getStoreName() === 'luxe';
          productsForGa.products = [
            {
              id: productCode,
              quantity: requestObj.qtyCanceled,
              dimension60: dimension60Data,
              ...(gwpDimension && { [isLuxe ? 'dimension82' : 'dimension166']: gwpDimension })
            }
          ];
        }
        const ga4AjioEnable = getGA4AJIOEnable(window?.__PRELOADED_STATE__?.flags);
        if (ga4AjioEnable) {
          const product = {
            id: productCode,
            quantity: Number(requestObj.qtyCanceled) || 1,
            segmentId: dimension60Data,
            name,
            index: Number(productIndex) || 0,
            brand: brandName,
            value: Number(finalPrice) || 0,
            tax: Number(tax) || 0,
            shipping: Number(productShipping) || 0,
            coupon: couponSavings,
            discount: Number(discount) || 0,
            list: 'consolidated order details screen',
            category: '',
            variant: '',
            price: Number(finalPrice) || 0,
            ...(gwpDimension && { offer_name: gwpDimension })
          };
          gtmGA4RefundEvent(
            orderId,
            product,
            'order management screen',
            'orders cancellation screen'
          );
        } else {
          gtmRefundEvent(
            orderId,
            productsForGa,
            'order management screen',
            'orders cancellation screen'
          );
        }
        gtmEventPush({
          event: 'return_interaction',
          event_category: 'cancel order interactions',
          event_action: 'cancel order successful',
          product_id: baseProduct,
          order_id: orderId,
          product_name: name,
          product_brand: brandName,
          product_size: size,
          page_type: 'order management screen',
          ...(giftItemQty > 0 && { offer_count: giftItemQty })
        });

        const { bankDiscountClawbackSegmentData = {} } = extraParams;
        const { clawback_amount = 0, payment_type = '' } = bankDiscountClawbackSegmentData || {};
        segmentEventPush({
          event: 'Cancel Request Status',
          cancel_request_status: 'Success',          
          order_id: orderId,
          order_status: '',          
          products: [
            {
              product_id: productCode,
              product_rating,
              number_of_ratings_collected,
              product_brick,
              product_vertical,
              product_segment,
              product_brand,
              product_tag
            }
          ],
          page_name: 'order cancellation screen',
          clawback_amount,
          payment_type,
          items: [{
            product_rating,
            number_of_ratings_collected,
            product_brick,
            product_vertical,
            product_segment,
            product_brand,
            product_tag
          }]
        })

        dispatch(hideLoader('order-loader'));
        dispatch(setErrorObject(messageBar));
        let timeout = setTimeout(() => {
          dispatch(setErrorObject({}));
          clearTimeout(timeout);
        }, 5000);
        if(cancelledProductDetails && cancelledProductDetails?.isRushOrderCancelled){                         //when rush order cancelled redirect to OLP page 
          window.location.href =  '/my-account/orders';
        }
        else{
          window.location.reload();
        }
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              cancelOrderItem(
                orderId,
                productCode,
                requestObj,
                enable_cancellation_request,
                cancelationRequestOldFlag,
                cancelledProductDetails
              )(dispatch);
            });
          }
          dispatch(setErrorObject(errorObj));
        });

        const { bankDiscountClawbackSegmentData = {} } = extraParams;
        const { clawback_amount = 0, payment_type = '' } = bankDiscountClawbackSegmentData || {};
        const {
          product_rating,
          number_of_ratings_collected,
          product_brick,
          product_vertical,
          product_segment,
          product_brand,
          product_tag,
        } = cancelledProductDetails;

        segmentEventPush({
          event:'Cancel Request Status',
          cancel_request_status: 'Error',          
          order_id: orderId,
          order_status: '',
          products: [{ product_id: productCode }],
          screen_name: 'order cancellation screen',
          clawback_amount,
          payment_type,
          items: [{
            product_rating,
            number_of_ratings_collected,
            product_brick,
            product_vertical,
            product_segment,
            product_brand,
            product_tag
          }]
        })
        dispatch(hideLoader('order-loader'));
      });
  };
}

// Based on Invoice number return product

export function returnReceivedInvoiceOrder(params, callback) {
  let { orderCode = '', consignmentCode = '', invoiceNum = '' } = params;

  return dispatch => {
    dispatch(showLoader('order-loader'));
    let apiEndPoint = `/api/my-account/return-invoice-order/${orderCode}/${consignmentCode}/${invoiceNum}`;

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'GET',
        headers: { 'content-type': 'application/json', credentials: 'include' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(hideLoader('order-loader'));
        let { errors = '', status = '' } = response || {};
        if (status === 'failed') {
          let messageBar = {
            errorType: 'info',
            message: errors,
            origin: 'invoice'
          };
          dispatch(setErrorObject(messageBar));
        } else {
          callback();
        }
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              returnReceivedInvoiceOrder(params, callback)(dispatch);
            });
          }
          dispatch(setErrorObject(errorObj));
        });
        dispatch(hideLoader('order-loader'));
      });
  };
}


function addScript(src) {
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');

    s.setAttribute('src', src);
    s.addEventListener('load', resolve);
    s.addEventListener('error', reject);

    document.body.appendChild(s);
  });
}
// IMPS Details Save
export function impsDetailsSave(requestObj = {}) {
  return async dispatch => {
    dispatch(showLoader('order-loader'));
    let apiEndPoint = `/api/my-account/save-imps-details`;
    if(requestObj.enableReturnBankInfoEncryption){
      await addScript('https://unpkg.com/node-forge@0.7.0/dist/forge.min.js');
      const { forge } = window;
      const {publicKey, versionForEncryption, ExtnBeneIFSC, ExtnBeneAccNo} = requestObj;
      const data = `${ExtnBeneAccNo}|${ExtnBeneIFSC}`;
      let encrypted64;
      if(forge){
        encrypted64 = getEncryptedData(publicKey, data,versionForEncryption )
      }
      requestObj.ExtnBeneIFSC = encrypted64;
      requestObj.ExtnBeneAccNo = encrypted64;
      requestObj.enableReturnBankInfoEncryption = String(requestObj.enableReturnBankInfoEncryption);
    }else{
      delete requestObj?.enableReturnBankInfoEncryption;
      delete requestObj?.publicKey;
      delete requestObj?.versionForEncryption;
    }


    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        body: JSON.stringify(requestObj),
        method: 'POST',
        headers: { 'content-type': 'application/json', credentials: 'include' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const { message = '', statusCode = '' } = response || {};
        let messageBar = {
          errorType: 'info',
          message: message || ''
        };
        const checkStatus = statusCode === '200';
        if (!checkStatus) {
          dispatch(setErrorObject(messageBar));
        }
        dispatch(setImpsDetail(response));
        // let messageBar = {
        //     errorType : "info",
        //     message : "We have successfully received your request.The refund amount should reflect in your bank account within 24 hours."
        // }
        dispatch(hideLoader('order-loader'));
        // dispatch(setErrorObject(messageBar));
        // let timeout = setTimeout(() => {
        //     dispatch(setErrorObject({}));
        //     window.location.reload();
        //     clearTimeout(timeout);
        // }, 1000);
        return Promise.resolve(response);
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              impsDetailsSave(orderId, productCode, requestObj)(dispatch);
            });
          }
          let messageBar = {
            errorType: 'info',
            message: 'something went wrong'
          };
          dispatch(setErrorObject(messageBar));
        });
        dispatch(hideLoader('order-loader'));
        return Promise.reject({});
      });
  };
}

export function downloadInvoiceCall(params) {
  let { orderId = '', consignmentCode = '' } = params;
  return dispatch => {
    dispatch(showLoader('order-loader'));
    return fetcher(
      `/api/order/invoiceDownload/${orderId}/${consignmentCode}`,
      fetchGetJSONReqOpts({
        method: 'GET',
        headers: { credentials: 'include', 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(hideLoader('order-loader'));
        let { hasError = true, invoicePdfContent = '' } = response;
        let data;
        if (hasError) {
          dispatch(
            showErrorMessageInfo({
              errorType: 'info',
              message:
                'We are unable to download your invoice at the moment. Please try after sometime'
            })
          );
        } else {
          data = `data:application/octet-stream;base64,${invoicePdfContent}`;
        }
        return Promise.resolve({ data });
      })
      .catch(error => {
        dispatch(hideLoader('order-loader'));
        dispatch(
          showErrorMessageInfo({
            errorType: 'info',
            message:
              'We are unable to download your invoice at the moment. Please try after sometime'
          })
        );
        return Promise.reject(error);
      });
  };
}

export function getReturnFee(products, orderCode, consignmentCode, cb) {
  return dispatch => {
    dispatch(showLoader('return-fee-loader'));
    const apiEndPoint = `/api/my-account/get-returnfee`;
    fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        body: JSON.stringify({
          products,
          orderCode,
          consignmentCode
        }),
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const { returnFee = 0 } = response;
        const parsedReturnFee = Number.parseFloat(returnFee).toFixed(2);
        if (parsedReturnFee > 0) {
          cb(response.returnFee);
        } else {
          dispatch(hideLoader('return-fee-loader'));
        }
      })
      .catch(error => {
        dispatch(hideLoader('return-fee-loader'));
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          dispatch(setErrorObject(errorObj));
        });
      });
  };
}

export function fetchIfscCodeDetails(ifscCode) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(showLoader('imps-process-loader'));

      if (!ifscCode)
        return Promise.reject({
          statusCode: 400,
          errorMessage: {
            error: {
              code: '',
              description: 'Please enter a valid IfSC code'
            }
          }
        });

      const clientEndpointUrl = `/api/my-account/fetchIfscCodeDetails/${ifscCode}`;
      return fetcher(
        clientEndpointUrl,
        fetchGetJSONReqOpts({
          method: 'GET',
          headers: { Accept: 'application/json' }
        })
      )
        .then(fetchGetJSONResHandler)
        .then(response => {
          dispatch(hideLoader('imps-process-loader'));
          resolve(response);
        })
        .catch(error => {
          dispatch(hideLoader('imps-process-loader'));
          let statusCode = getErrorStatusCode(error);
          errorParser(error, statusCode).then((errorObj = {}) => {
            reject(errorObj);
            // reject(error, statusCode);
          });
        });
    });
  };
}

export function getQuesAnsDetail(orderId, entryNum, itemStatus) {
  return dispatch => {
    const apiEndPoint = `/api/selfcare/getQuesAnsDetail/${orderId}/${entryNum}/${itemStatus}`;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'GET',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const { isLuxuryOrder = false, quickLinksList = [] } = response;
        console.log('RESPONSE getQuesAnsDetail', response);
        dispatch(
          getQuesAnsResponse({
            isLuxuryOrder,
            quickLinksList
          })
        );
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          dispatch(setErrorObject(errorObj));
        });
      });
  };
}
